import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./components/App/App";
import registerServiceWorker from "./storage/serviceWorker/register";
import { isCordovaApp } from "./utils/cordovaUtils";

let Router: any;

const startApp = () =>
  ReactDOM.render(
    <Router>
      <App />
    </Router>,
    document.getElementById("root")
  );

if (!isCordovaApp) {
  Router = BrowserRouter;
  startApp();
  registerServiceWorker();
} else {
  Router = HashRouter;
  document.addEventListener("deviceready", startApp, false);
}
